export default __webpack_public_path__ + "static/media/pantry1-afterD-480w.19a6c361.webp";